
import React, { useEffect, useState } from 'react';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import { components } from 'react-select';

const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<span className="icon icon--search"></span>
		</components.DropdownIndicator>
	);
};

/**
 *
 * @param {GooglePlacesAutocomplete Value} value
 * @param {func} onChange
 * @param {boolean} inReact // if it is inside the React container, if not, it needs [defaultValue, setDefaultValue]
 *
 */
const ReactGoogleAutocomplete = ({value, onChange, inReact = true}) => {
	const [defaultValue, setDefaultValue] = useState(null);

	useEffect(() => {
		if(inReact === false) {
			console.log(defaultValue);
			window.reactMakeAppointmentContainerData.googleAutocompleteData = defaultValue;
		}
	}, [defaultValue]);

	return (
		<GooglePlacesAutocomplete
			apiKey="AIzaSyCBVt9tsVCU8LFazxe-yILofaLKAlkqv0I"
			/**
			 * reference for select props settings
			 * https://react-select.com/styles
			 */
			selectProps={{
				defaultValue: inReact === true ? value : defaultValue,
				onChange: inReact === true ? onChange : setDefaultValue,
				components: {
					DropdownIndicator,
					IndicatorSeparator: null
				}
			}}
			/**
			 * reference for options settings
			 * https://tintef.github.io/react-google-places-autocomplete/docs/props
			 */
			autocompletionRequest={{
				componentRestrictions: {
					// country: ['au', 'nz'],
					country: ['au'],
				}
			}}
		/>

	);
};

export default ReactGoogleAutocomplete;
